import {
  Client,
  InProgressResponse,
  STORAGE_TTL,
  StoredConversation,
  storedConversations,
} from '@stripe-internal/conversations-client';

export const STORED_TTL: STORAGE_TTL = {value: 30, unit: 'minutes'};

export function getStoredConversations(): StoredConversation[] {
  return storedConversations({ttl: STORED_TTL});
}

export function getStoredConversation({
  audience,
  entryPoint,
  userId,
}: {
  audience?: string;
  entryPoint?: string;
  userId?: string;
} = {}): StoredConversation | null {
  const stored = getStoredConversations();

  if (stored.length === 0) {
    return null;
  }

  const storedConversation = stored.find((conversation) => {
    if (audience && conversation.data?.context?.audience !== audience) {
      return false;
    }
    if (entryPoint && conversation.data?.context?.entryPoint !== entryPoint) {
      return false;
    }
    if (userId && conversation.data?.context?.userId !== userId) {
      return false;
    }
    return true;
  });

  return storedConversation ?? null;
}

export async function getInProgressStoredConversation({
  storedConversation,
  client,
  audience,
  entryPoint,
  universalHelpFindConversationByEntryPoint,
}: {
  storedConversation?: StoredConversation | null;
  client: Client;
  audience: string;
  entryPoint: string;
  universalHelpFindConversationByEntryPoint: boolean;
}): Promise<{
  inProgressResponse: InProgressResponse;
  storedConversation: StoredConversation | undefined | null;
} | null> {
  let stored: StoredConversation | undefined | null;
  if (storedConversation) {
    stored = storedConversation;
  } else {
    stored = getStoredConversation({
      entryPoint: universalHelpFindConversationByEntryPoint
        ? entryPoint
        : undefined,
      audience: universalHelpFindConversationByEntryPoint
        ? undefined
        : audience,
    });
  }

  const inProgressResp = await client.inProgress({
    conversationId: stored?.id,
    context: stored?.data?.context ?? {
      audience,
      entryPoint,
    },
  });

  if ('error' in inProgressResp) {
    return null;
  }

  return {
    inProgressResponse: inProgressResp,
    storedConversation: stored,
  };
}
